import { useCallback } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { notify } from '../notify/notify'
import './blob.css'
import CopySvg from '../common/components/svg/CopySvg'
export interface BlobModalComponentProperties {
  modalVisible: boolean
  closeModal: any
  blobName: string
  blobData: any
  raw?: string
}

const BlobModalComponent = (props: BlobModalComponentProperties) => {
  const handleCopyClicked = useCallback((e) => {
    const copy = async function(){
      if (!props.raw) return

      await navigator.clipboard.writeText(props.raw)
      notify('success', 'Copied content to clipboard!')
    }
    copy()
  }, [props.raw])

  return (
    <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
      <Modal.Header 
        closeButton
        style={{ 
          position: 'sticky', 
          top: -1, 
          zIndex: 1050, 
          backgroundColor: 'white', 
          borderBottom: '1px solid #ddd'
        }}
      >
        <Modal.Title>
          {props.blobName}
          {props.raw && 
            <>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className='button-like' style={{float: 'right', cursor: 'pointer'}} title='Copy content to clipboard' onClick={handleCopyClicked}>
                <CopySvg height={16} />
              </span>
            </>
          }
        </Modal.Title>
      </Modal.Header>
        
      <Modal.Body>
        {props.blobData}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={props.closeModal}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BlobModalComponent
